"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssigneeStandardPerformance = void 0;
var __1 = require("../..");
/**
 * It holds standard performance information about an specific assignee
 *
 * @author fabian.perez
 */
var AssigneeStandardPerformance = /** @class */ (function () {
    function AssigneeStandardPerformance(assigneeStandardPerformance) {
        if (assigneeStandardPerformance === void 0) { assigneeStandardPerformance = {}; }
        Object.assign(this, assigneeStandardPerformance);
    }
    /**
     * Returns the standard performance matching the standard
     * @param {string} standard
     *
     * @return {StandardPerformance | undefined} the standard performance matching the standard if any
     */
    AssigneeStandardPerformance.prototype.standardPerformanceByStandard = function (standard) {
        return (this.standardsPerformance || []).find(function (performance) { return performance.standard === standard; });
    };
    /**
     * Returns the standard performance for the provided assignees standard performance records
     * @param standard
     * @param assigneesStandardPerformance
     *
     * @return { { maxScore: number, score: number } } the overall performance
     */
    AssigneeStandardPerformance.calculatePerformanceByStandard = function (standard, assigneesStandardPerformance) {
        var byStandard = [];
        assigneesStandardPerformance.forEach(function (assigneeStandardPerformance) {
            var standardPerformance = assigneeStandardPerformance.standardPerformanceByStandard(standard);
            if (standardPerformance) {
                byStandard.push(standardPerformance);
            }
        });
        var _a = __1.StandardPerformance.calculatePerformance(byStandard), maxScore = _a.maxScore, score = _a.score;
        return {
            maxScore: maxScore,
            score: score,
            attempted: byStandard.filter(function (_a) {
                var attempted = _a.attempted;
                return attempted;
            }).length > 0,
        };
    };
    return AssigneeStandardPerformance;
}());
exports.AssigneeStandardPerformance = AssigneeStandardPerformance;
